import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=97108b44&scoped=true&lang=pug&"
import script from "./Support.vue?vue&type=script&lang=js&"
export * from "./Support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97108b44",
  null
  
)

export default component.exports